import {
  can,
  canOn,
  entitlementLimit,
  hasEntitlement,
  selectActiveMembership,
  selectEntitlements,
  selectPermissions
} from "./chunk-YXNSSCIE.js";

// src/react/index.ts
import { createContext, createElement, useContext } from "react";
import { useStore } from "zustand";
var SessionStoreContext = createContext(null);
function SessionStoreProvider({
  store,
  children
}) {
  return createElement(SessionStoreContext.Provider, { value: store }, children);
}
function useSessionStoreApi() {
  const store = useContext(SessionStoreContext);
  if (!store) throw new Error("useSession* hooks need a <SessionStoreProvider>");
  return store;
}
function useSession(selector) {
  return useStore(useSessionStoreApi(), selector);
}
var useActiveMembership = () => useSession(selectActiveMembership);
function useCan(...keys) {
  return can(useSession(selectPermissions), ...keys);
}
function useCanOn(resourcePermissions, relation) {
  return canOn(resourcePermissions, relation);
}
function useEntitlement(key) {
  const entitlements = useSession(selectEntitlements);
  return { enabled: hasEntitlement(entitlements, key), limit: entitlementLimit(entitlements, key) };
}
export {
  SessionStoreProvider,
  useActiveMembership,
  useCan,
  useCanOn,
  useEntitlement,
  useSession
};
//# sourceMappingURL=react.js.map